import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useGlobalPopupOpenListener = () => {
    const dispatch = useDispatch();

    const handleOpenPopupClick = useCallback((event: MouseEvent) => {
        const target = (event.target as HTMLElement)?.closest?.('.fn-popup-open') as HTMLElement;

        if (!target) {
            return;
        }

        event.preventDefault();

        const popupParams = target.dataset || {};

        if (Object.keys(popupParams).length > 0) {
            dispatch(showCommonPopupAction(popupParams));
        }
    }, [dispatch]);

    useEffect(() => {
        document.body.addEventListener('click', handleOpenPopupClick);

        return () => {
            document.body.removeEventListener('click', handleOpenPopupClick);
        };
    }, [handleOpenPopupClick]);
};
